import { formatConvertedDateTime } from "@/lib/Util";

export function formatTimezonedDateTime(value: string) {
  if (value) {
    return formatConvertedDateTime(value);
  }
  return;
}